import * as React from 'react';
import { UseFieldArrayReturn, UseFormRegister } from 'react-hook-form';
import { SkillForm } from './AgentSkillsComponent';
import { Input } from '../../../../ui/input';
import { Button } from '../../../../ui/button';
import { PlusCircle, Trash2 } from 'lucide-react';
import { ScrollArea } from '../../../../ui/scroll-area';
import { AnimatePresence, motion } from 'framer-motion';
import { EnumSkillRetrieverFields } from 'src/types/Common';

// type extendForm =
//     'skills'
//     | `skills.${number}.config.params`
//     | `skills.${number}.config.headers`
//     | `privacy.white_list_ips`
//     | `privacy.white_list_countries`
//     | `privacy.white_list_source`
//     | 'new_skill.config.params'
//     | 'new_skill.config.headers'

type Props = {
    formArray: UseFieldArrayReturn<any, any, 'id'>
    register: UseFormRegister<any>
    label: string
    buttonLabel: string
    append: () => void
    placeholderKey?: string
    placeholderValue?: string
    disabled?: boolean;
    config?: "config" | "config.action_retriever_config" | string
    name: 'params' | 'headers' | 'white_list_ips'
        | 'white_list_countries' | 'white_list_source'
        | 'columns_to_find' | 'columns_to_return'
        | 'fields_to_find' | 'fields_to_return'
        | 'columns_description'
        | `${string}.columns_to_find` | `${string}.fields_to_return`
        | `${string}.fields_to_find` | `${string}.columns_to_return`;
        onchange?: (field: EnumSkillRetrieverFields) => void;
};

function SkillKeyValueConfigComponent({
                                          formArray,
                                          register,
                                          label,
                                          append,
                                          name, config = "config",
                                          buttonLabel, placeholderKey = 'key', placeholderValue = 'value',
                                          onchange,
                                          disabled
                                      }: Props) {


    const getName = (type: 'name' | 'value', index: number): keyof SkillForm => {
        if (['params', 'headers', 'columns_to_find', 'columns_to_return', 'fields_to_find', 'fields_to_return', 'columns_description'].includes(name)) {

            return `new_skill.${config}.${name}.${index}.${type}` as keyof SkillForm;
        }

        if (['white_list_ips', 'white_list_countries', 'white_list_source'].includes(name)) {
            return `privacy.${name}.${index}.${type}` as keyof SkillForm;
        }

        return '' as keyof SkillForm;
    };

    return (
        <div className="flex flex-col gap-2">
            <span className="form-input-label">{label}</span>
            <ScrollArea className="max-h-[300px] overflow-y-auto">
                <AnimatePresence initial={false}>
                    {formArray.fields.map((field, index) => (
                        <motion.div
                            key={field.id}
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3 }}
                            className=""
                        >
                            <div className="flex items-center p-2 gap-2">
                                <Input
                                    {...register(getName('name', index))}
                                    placeholder={placeholderKey}
                                    className="flex-1"
                                    disabled={disabled}
                                    /* It is typed as undefined because the parameter expects
                                    a React.ChangeEventHandler<HTMLInputElement> function but
                                    the onchange function is of another
                                    type and is called from outside in order to pass the group to it. */
                                    onChange={onchange as undefined}
                                />
                                <Input
                                    {...register(getName('value', index))}
                                    placeholder={placeholderValue}
                                    className="flex-1"
                                    disabled={disabled}
                                    /* It is typed as undefined because the parameter expects
                                    a React.ChangeEventHandler<HTMLInputElement> function but
                                    the onchange function is of another
                                    type and is called from outside in order to pass the group to it. */
                                    onChange={onchange as undefined}
                                />
                                <Button
                                    type="button"
                                    variant="ghost"
                                    size="icon"
                                    disabled={disabled}
                                    onClick={() => formArray.remove(index)}
                                >
                                    <Trash2 className="h-4 w-4" />
                                </Button>
                            </div>
                        </motion.div>
                    ))}
                </AnimatePresence>
            </ScrollArea>
            <div className="flex items-center justify-between">
                <Button
                    type="button"
                    onClick={append}
                    disabled={disabled}
                    size={'sm'}
                    className="bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-3xl"
                >
                    <PlusCircle className=" mr-1 h-4 w-4" />
                    {buttonLabel}
                </Button>
                {/*<div className="text-sm text-gray-500">*/}
                {/*    Total: {formArray.fields.length}*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default SkillKeyValueConfigComponent;